import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core'
import { FilterBarComponent } from 'app/common'
import { animate, state, style, transition, trigger } from '@angular/animations'
import { Colors } from 'app/common/config/constants'
import { Delivery, Vertical } from 'app/models/Vertical'
import { merge } from 'rxjs'

@Component({
  standalone: false,
  selector: 'app-campaign-filter-bar',
  templateUrl: './../filter-bar/filter-bar.component.html',
  styleUrls: [
    './../filter-bar/filter-bar.component.scss',
    './campaign-filter-bar.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('openCloseFilterBar', [
      state('close', style({ width: '0' })),
      state('open', style({ width: '240px' })),
      transition('close <=> open', animate(`500ms ease-out`)),
    ]),
    trigger('openCloseToggleBtn', [
      state(
        'close',
        style({
          transform: 'translateX(calc(-100% - 24px)) rotateY(0deg)',
          backgroundColor: Colors.colorWhite,
          boxShadow: '0 0 6px 0 color.adjust($colorBlack, $alpha: -0.75)',
        }),
      ),
      state(
        'open',
        style({
          transform: 'translateX(-50%) rotateY(180deg)',
          backgroundColor: Colors.colorN100,
          boxShadow: '0 0 6px 0 color.adjust($colorBlack, $alpha: -1)',
        }),
      ),
      transition('close <=> open', animate(`500ms ease-out`)),
    ]),
  ],
})
export class CampaignFilterBarComponent
  extends FilterBarComponent
  implements OnInit
{
  compareSelectorLabel = 'Campaign comparison'
  deliveriesLabel = 'Campaigns'

  get currentDelivery(): Delivery {
    return this._currentDelivery
  }

  @Input()
  set currentDelivery(value: Delivery) {
    this._currentDelivery = value
    this.initFilters()
    this.changes.markForCheck()
  }

  @Input()
  set deliveries(val: any) {
    ;(val || []).sort((a, b) => {
      if (a.name.toLowerCase() < b.name.toLowerCase()) {
        return -1
      }
      if (a.name.toLowerCase() > b.name.toLowerCase()) {
        return 1
      }
      return 0
    })
    this._deliveries = val
    this._compareDeliveries = this._deliveries.filter(
      (delivery) => delivery !== this._currentDelivery,
    )
    this.changes.markForCheck()
  }

  @Output() onChangeDelivery = new EventEmitter()

  get deliveries() {
    return this._deliveries.map((delivery: Delivery) => {
      return { label: delivery.name, value: delivery.id }
    })
  }

  get isVisitsAvailable() {
    return this.context.isVisitsAvailable()
  }

  private _currentDelivery: Delivery = null

  protected hasMobilityFilters() {
    return (
      this._currentDelivery && this._currentDelivery.filtersMobility.length > 0
    )
  }

  initFilters(vertical: Vertical = null) {
    if (!this._currentDelivery) {
      return
    }
    this.shown = this.context.filterBarOpen
    const useMobility = this.context.poi && this.hasMobilityFilters()
    const contextFilters = useMobility
      ? this._currentDelivery.filtersMobility
      : this._currentDelivery.filters
    this._filters = []
    for (const name in contextFilters) {
      if (contextFilters[name]) {
        this._filters.push(contextFilters[name])
      }
    }
    const campaignTarget = this._currentDelivery.target
    this._target =
      (campaignTarget?.hasSubfilters() ? campaignTarget : null) ||
      this.context.vertical?.delivery?.target
    this._compareDeliveries = this._deliveries.filter(
      (delivery) => delivery !== this._currentDelivery,
    )
    this.brand = this.context.organization.name
    this.changes.markForCheck()
  }

  ngOnInit() {
    this.subscriptions.add(
      merge(
        this.context.$currentVertical,
        this.context.filterChanges,
      ).subscribe(() => {
        this.initFilters()
      }),
    )
    this.shown = this.context.filterBarOpen
  }

  changeDelivery(newDelivery) {
    const delivery = this._deliveries.find(
      (item) => Number(item.id) === Number(newDelivery.value),
    )
    delivery.variablesKey = this.currentDelivery.variablesKey
    this._compareDeliveries = this._deliveries.filter((del) => del !== delivery)
    this.openCurrentDelivery = false
    this.onChangeDelivery.emit(delivery)
    if (this.compareDelivery && delivery.id === this.compareDelivery.id) {
      this.changeCompareDelivery(null)
    }
    this.changes.markForCheck()
  }
}
